<!-- ============ HERO ============ -->
<section class="hero-cont">
    <div>
        <div class="uc-hero__banner">
            <img class="uc-hero__bg" src="assets\img\company\vr-main.png"
                [alt]="'VR_MAIN.HERO.IMAGE_ALT' | translate" />

            <div class="uc-hero__overlay">
                <span class="uc-badge">
                    <i class="pi pi-sparkles"></i>
                    {{ 'VR_MAIN.HERO.BADGE' | translate }}
                </span>
                <h1 class="uc-hero__title">{{ 'VR_MAIN.HERO.TITLE' | translate }}</h1>
                <p class="uc-hero__subtitle">{{ 'VR_MAIN.HERO.SUBTITLE' | translate }}</p>

                <div class="uc-hero__cta" (click)="goToVrPage()">
                    <button class="jp-hero-cta">
                        <span>{{ 'VR_MAIN.HERO.CTA' | translate }}</span>
                        <span class="jp-cta-arrow">
                            <i class="bi bi-arrow-up-right"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- ============ WHY TOP TEAMS CHOOSE US ============ -->
<app-why-top-teams></app-why-top-teams>

<!-- ============ SEAMLESS HIRING WORKFLOW ============ -->
<section class="uc-workflow">
    <div class="uc-container">
        <h2 class="section-title uc-center-title">{{ 'VR_MAIN.WORKFLOW.TITLE' | translate }}</h2>

        <div class="uc-workflow__steps">
            <div class="uc-step">
                <div class="uc-step__circle uc-step__circle--outline">
                    <span>1</span>
                </div>
                <h3 class="uc-step__title">{{ 'VR_MAIN.WORKFLOW.STEP1.TITLE' | translate }}</h3>
                <p class="uc-step__desc">{{ 'VR_MAIN.WORKFLOW.STEP1.DESC' | translate }}</p>
            </div>

            <div class="uc-step__line"></div>

            <div class="uc-step">
                <div class="uc-step__circle uc-step__circle--accent">
                    <i class="pi pi-bolt"></i>
                </div>
                <h3 class="uc-step__title">{{ 'VR_MAIN.WORKFLOW.STEP2.TITLE' | translate }}</h3>
                <p class="uc-step__desc">{{ 'VR_MAIN.WORKFLOW.STEP2.DESC' | translate }}</p>
            </div>

            <div class="uc-step__line"></div>

            <div class="uc-step">
                <div class="uc-step__circle uc-step__circle--muted">
                    <i class="pi pi-file"></i>
                </div>
                <h3 class="uc-step__title">{{ 'VR_MAIN.WORKFLOW.STEP3.TITLE' | translate }}</h3>
                <p class="uc-step__desc">{{ 'VR_MAIN.WORKFLOW.STEP3.DESC' | translate }}</p>
            </div>

            <div class="uc-step__line"></div>

            <div class="uc-step">
                <div class="uc-step__circle uc-step__circle--dark">
                    <i class="pi pi-check"></i>
                </div>
                <h3 class="uc-step__title">{{ 'VR_MAIN.WORKFLOW.STEP4.TITLE' | translate }}</h3>
                <p class="uc-step__desc">{{ 'VR_MAIN.WORKFLOW.STEP4.DESC' | translate }}</p>
            </div>
        </div>
    </div>
</section>

<!-- ============ INTERVIEW BUILDER ============ -->
<section class="uc-builder">
    <div class="uc-container uc-builder__inner">
        <div class="uc-builder__content">
            <span class="uc-eyebrow">{{ 'VR_MAIN.BUILDER.EYEBROW' | translate }}</span>
            <h2 class="description-title">{{ 'VR_MAIN.BUILDER.TITLE' | translate }}</h2>
            <p class="description">{{ 'VR_MAIN.BUILDER.SUBTITLE' | translate }}</p>

            <ul class="uc-checklist">
                <li>
                    <i class="pi pi-check-circle"></i>
                    <span>{{ 'VR_MAIN.BUILDER.POINT1' | translate }}</span>
                </li>
                <li>
                    <i class="pi pi-check-circle"></i>
                    <span>{{ 'VR_MAIN.BUILDER.POINT2' | translate }}</span>
                </li>
                <li>
                    <i class="pi pi-check-circle"></i>
                    <span>{{ 'VR_MAIN.BUILDER.POINT3' | translate }}</span>
                </li>
            </ul>

            <button class="gradient-button" type="button" (click)="goToVrPage()">
                {{ 'VR_MAIN.BUILDER.CTA' | translate }}
            </button>
        </div>

        <div class="uc-builder__media">
            <div class="uc-interview-card">
                <span class="uc-interview-card__badge">{{ 'VR_MAIN.BUILDER.CARD.BADGE' | translate }}</span>

                <span class="uc-interview-card__q-number">{{ 'VR_MAIN.BUILDER.CARD.Q_LABEL' | translate }}</span>
                <p class="uc-interview-card__question">{{ 'VR_MAIN.BUILDER.CARD.QUESTION' | translate }}</p>

                <label class="uc-interview-card__label">{{ 'VR_MAIN.BUILDER.CARD.CLARIFICATIONS_LABEL' | translate
                    }}</label>
                <div class="uc-interview-card__field">{{ 'VR_MAIN.BUILDER.CARD.CLARIFICATIONS_PLACEHOLDER' | translate
                    }}</div>

                <label class="uc-interview-card__label">{{ 'VR_MAIN.BUILDER.CARD.ANSWER_LABEL' | translate }}</label>
                <div class="uc-interview-card__field uc-interview-card__field--answer">
                    {{ 'VR_MAIN.BUILDER.CARD.ANSWER_TEXT' | translate }}
                </div>

                <div class="uc-interview-card__avatar">
                    <i class="pi pi-android"></i>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- ============ AI CANDIDATE EVALUATION ============ -->
<section class="uc-evaluation">
    <div class="uc-container">
        <h2 class="section-title uc-center-title">{{ 'VR_MAIN.EVALUATION.TITLE' | translate }}</h2>
        <p class="uc-section-subtitle">{{ 'VR_MAIN.EVALUATION.SUBTITLE' | translate }}</p>

        <div class="uc-evaluation__grid">
            <div class="uc-evaluation__col">
                <div class="uc-panel">
                    <h4 class="uc-panel__title">{{ 'VR_MAIN.EVALUATION.QUESTION_REVIEW.TITLE' | translate }}</h4>

                    <div class="uc-qa-row">
                        <p class="uc-qa-row__q">{{ 'VR_MAIN.EVALUATION.QUESTION_REVIEW.Q1' | translate }}</p>
                        <p class="uc-qa-row__a">{{ 'VR_MAIN.EVALUATION.QUESTION_REVIEW.A1' | translate }}</p>
                    </div>
                    <div class="uc-qa-row">
                        <p class="uc-qa-row__q">{{ 'VR_MAIN.EVALUATION.QUESTION_REVIEW.Q2' | translate }}</p>
                        <p class="uc-qa-row__a">{{ 'VR_MAIN.EVALUATION.QUESTION_REVIEW.A2' | translate }}</p>
                    </div>
                </div>

                <div class="uc-panel">
                    <h4 class="uc-panel__title">{{ 'VR_MAIN.EVALUATION.INSIGHTS.TITLE' | translate }}</h4>

                    <div class="uc-insight uc-insight--positive">
                        <span class="uc-insight__label">
                            <i class="pi pi-thumbs-up"></i>
                            {{ 'VR_MAIN.EVALUATION.INSIGHTS.STRENGTHS_LABEL' | translate }}
                        </span>
                        <p>{{ 'VR_MAIN.EVALUATION.INSIGHTS.STRENGTHS_TEXT' | translate }}</p>
                    </div>

                    <div class="uc-insight uc-insight--negative">
                        <span class="uc-insight__label">
                            <i class="pi pi-thumbs-down"></i>
                            {{ 'VR_MAIN.EVALUATION.INSIGHTS.CONCERNS_LABEL' | translate }}
                        </span>
                        <p>{{ 'VR_MAIN.EVALUATION.INSIGHTS.CONCERNS_TEXT' | translate }}</p>
                    </div>
                </div>
            </div>

            <div class="uc-evaluation__col">
                <div class="uc-panel">
                    <h4 class="uc-panel__title">{{ 'VR_MAIN.EVALUATION.SUMMARY.TITLE' | translate }}</h4>

                    <div class="uc-summary-stats">
                        <div class="uc-summary-stat">
                            <span class="uc-summary-stat__label">{{ 'VR_MAIN.EVALUATION.SUMMARY.SCORE_LABEL' | translate
                                }}</span>
                            <span class="uc-summary-stat__value">86/100</span>
                        </div>
                        <div class="uc-summary-stat uc-summary-stat--positive">
                            <span class="uc-summary-stat__label">{{ 'VR_MAIN.EVALUATION.SUMMARY.RECOMMENDATION_LABEL' |
                                translate }}</span>
                            <span class="uc-summary-stat__value">{{ 'VR_MAIN.EVALUATION.SUMMARY.RECOMMENDATION_VALUE' |
                                translate }}</span>
                        </div>
                        <div class="uc-summary-stat">
                            <span class="uc-summary-stat__label">{{ 'VR_MAIN.EVALUATION.SUMMARY.DURATION_LABEL' |
                                translate }}</span>
                            <span class="uc-summary-stat__value">46 {{ 'VR_MAIN.EVALUATION.SUMMARY.MINUTES' | translate
                                }}</span>
                        </div>
                    </div>
                </div>

                <div class="uc-panel">
                    <h4 class="uc-panel__title">{{ 'VR_MAIN.EVALUATION.BREAKDOWN.TITLE' | translate }}</h4>

                    <div class="uc-breakdown-row">
                        <span>{{ 'VR_MAIN.EVALUATION.BREAKDOWN.COMMUNICATION' | translate }}</span>
                        <i class="pi pi-check-circle uc-status uc-status--good"></i>
                    </div>
                    <div class="uc-breakdown-row">
                        <span>{{ 'VR_MAIN.EVALUATION.BREAKDOWN.ROLE_KNOWLEDGE' | translate }}</span>
                        <i class="pi pi-times-circle uc-status uc-status--bad"></i>
                    </div>
                    <div class="uc-breakdown-row">
                        <span>{{ 'VR_MAIN.EVALUATION.BREAKDOWN.PROBLEM_SOLVING' | translate }}</span>
                        <i class="pi pi-exclamation-circle uc-status uc-status--warn"></i>
                    </div>
                    <div class="uc-breakdown-row">
                        <span>{{ 'VR_MAIN.EVALUATION.BREAKDOWN.CONFIDENCE' | translate }}</span>
                        <i class="pi pi-check-circle uc-status uc-status--good"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- ============ PRICING ============ -->
<section class="uc-pricing">
    <div class="uc-container">
        <h2 class="section-title uc-center-title">{{ 'VR_MAIN.PRICING.TITLE' | translate }}</h2>
        <p class="uc-section-subtitle">{{ 'VR_MAIN.PRICING.SUBTITLE' | translate }}</p>

        <div class="uc-pricing__grid">
            <div class="uc-price-card">
                <h3 class="uc-price-card__name">{{ 'VR_MAIN.PRICING.STARTER.NAME' | translate }}</h3>
                <div class="uc-price-card__price">
                    $0 <span>/ {{ 'VR_MAIN.PRICING.PER_MONTH' | translate }}</span>
                </div>
                <p class="uc-price-card__quota">{{ 'VR_MAIN.PRICING.STARTER.QUOTA' | translate }}</p>
                <button class="border-button" type="button">{{ 'VR_MAIN.PRICING.SELECT' | translate }}</button>
                <span class="uc-price-card__edits">{{ 'VR_MAIN.PRICING.STARTER.EDITS' | translate }}</span>
            </div>

            <div class="uc-price-card">
                <h3 class="uc-price-card__name">{{ 'VR_MAIN.PRICING.GROWTH.NAME' | translate }}</h3>
                <div class="uc-price-card__price">
                    $0 <span>/ {{ 'VR_MAIN.PRICING.PER_MONTH' | translate }}</span>
                </div>
                <p class="uc-price-card__quota">{{ 'VR_MAIN.PRICING.GROWTH.QUOTA' | translate }}</p>
                <button class="border-button" type="button">{{ 'VR_MAIN.PRICING.SELECT' | translate }}</button>
                <span class="uc-price-card__edits">{{ 'VR_MAIN.PRICING.GROWTH.EDITS' | translate }}</span>
            </div>

            <div class="uc-price-card">
                <h3 class="uc-price-card__name">{{ 'VR_MAIN.PRICING.BUSINESS.NAME' | translate }}</h3>
                <div class="uc-price-card__price">
                    $15 <span>/ {{ 'VR_MAIN.PRICING.PER_MONTH' | translate }}</span>
                </div>
                <p class="uc-price-card__quota">{{ 'VR_MAIN.PRICING.BUSINESS.QUOTA' | translate }}</p>
                <button class="border-button" type="button">{{ 'VR_MAIN.PRICING.SELECT' | translate }}</button>
                <span class="uc-price-card__edits">{{ 'VR_MAIN.PRICING.BUSINESS.EDITS' | translate }}</span>
            </div>

            <div class="uc-price-card uc-price-card--popular">
                <span class="uc-price-card__ribbon">{{ 'VR_MAIN.PRICING.POPULAR_LABEL' | translate }}</span>
                <h3 class="uc-price-card__name">{{ 'VR_MAIN.PRICING.PROFESSIONAL.NAME' | translate }}</h3>
                <div class="uc-price-card__price">
                    $35 <span>/ {{ 'VR_MAIN.PRICING.PER_MONTH' | translate }}</span>
                </div>
                <p class="uc-price-card__quota">{{ 'VR_MAIN.PRICING.PROFESSIONAL.QUOTA' | translate }}</p>
                <button class="gradient-button" type="button">{{ 'VR_MAIN.PRICING.SELECT' | translate }}</button>
                <span class="uc-price-card__edits">{{ 'VR_MAIN.PRICING.PROFESSIONAL.EDITS' | translate }}</span>
            </div>

            <div class="uc-price-card">
                <h3 class="uc-price-card__name">{{ 'VR_MAIN.PRICING.ENTERPRISE.NAME' | translate }}</h3>
                <div class="uc-price-card__price">
                    $15 <span>/ {{ 'VR_MAIN.PRICING.PER_MONTH' | translate }}</span>
                </div>
                <p class="uc-price-card__quota">{{ 'VR_MAIN.PRICING.ENTERPRISE.QUOTA' | translate }}</p>
                <button class="border-button" type="button">{{ 'VR_MAIN.PRICING.SELECT' | translate }}</button>
                <span class="uc-price-card__edits">{{ 'VR_MAIN.PRICING.ENTERPRISE.EDITS' | translate }}</span>
            </div>
        </div>
    </div>
</section>

<!-- ============ FINAL CTA ============ -->
<!-- <section class="uc-cta">

    <div class="uc-container uc-cta__inner">
        <div class="uc-cta__content">
            <h2 class="description-title">{{ 'VR_MAIN.CTA.TITLE' | translate }}</h2>
            <p class="description">{{ 'VR_MAIN.CTA.SUBTITLE' | translate }}</p>
            <button class="border-button" type="button">{{ 'VR_MAIN.CTA.BUTTON' | translate }}</button>
        </div>
        <div class="uc-cta__media">
            <div class="uc-cta__shape uc-cta__shape--circle"></div>
            <div class="uc-cta__shape uc-cta__shape--square"></div>
            <img class="uc-cta__img" src="assets/images/vr-main/cta-person.png"
                [alt]="'VR_MAIN.CTA.IMAGE_ALT' | translate" />
        </div>
    </div>
</section> -->
<app-start-achieving-section></app-start-achieving-section>